#import "../../../graphql/fragments/coordinates-fragment.graphql"
#import "../../../graphql/fragments/location-weather-fragment.graphql"
#import "../../../../core-entity/graphql/fragments/widget-fragment.graphql"
#import "../../../graphql/fragments/creator-user-fragment.graphql"
#import "./contact-primary-account-fragment.graphql"
#import "../../../graphql/fragments/peep-tag-maps-fragment.graphql"
#import "../../../../core-entity/graphql/fragments/header-field-fragment.graphql"

fragment ContactPageFragment on Contact {
    id
    isDeleted
    name
    description
    avatarUrl
    hasUploadedAvatar
    canDeleteAvatar
    createdTime
    territory {
        id
        name
    }
    creatorUser {
        ...CreatorUserFragment
    }
    owner {
        id
    }
    primaryAccount {
        ...ContactPrimaryAccountFragment
    }
    workspaceWidgets {
        ...WidgetFragment
    }
    sidebarWidgets {
        ...WidgetFragment
    }
    headerFields {
        ...HeaderFieldFragment
    }
    postalAddresses {
        primary {
            location {
                coordinates {
                    ...CoordinatesFragment
                }
                weather {
                    ...LocationWeatherFragment
                }
            }
        }
    }
    ...PeepTagMapsFragment
}
